<template>
    <div>
        <div class="social-container">
            <div class="social-container__description">
                Follow Ylands and never miss any updates!
            </div>
            <div class="social-container__logo">
                <a href="https://twitter.com/ylandsgame" target="_blank">
                    <twitter-logo></twitter-logo>
                </a>
            </div>
            <div class="social-container__logo">
                <a
                    href="https://www.youtube.com/c/YlandsGame/featured"
                    target="_blank"
                >
                    <youtube-logo></youtube-logo>
                </a>
            </div>
            <div class="social-container__logo">
                <a href="https://www.instagram.com/ylandsgame/" target="_blank">
                    <instagram-logo></instagram-logo>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import TwitterLogo from 'Svgs/twitter-logo.svg?inline';
import InstagramLogo from 'Svgs/instagram-logo.svg?inline';
import YoutubeLogo from 'Svgs/youtube-logo.svg?inline';
export default {
    name: 'SidebarSocialNetworks',
    components: {
        YoutubeLogo,
        InstagramLogo,
        TwitterLogo,
    },
};
</script>

<style scoped lang="scss">
.social-container {
    display: grid;
    grid-template-columns: repeat(3, 6rem);
    grid-auto-rows: 6rem 6rem;
    margin: 0;
    padding-left: 40px;
    @media (max-width: $lg-up) {
        padding-left: 30px;
    }
    @media (max-width: $sm-up) {
        grid-auto-rows: 3rem 3rem;
    }
    @media (min-width: $xxs-up) and (max-width: $xs-up) {
        grid-auto-rows: 3rem 3rem;
    }
    &__description {
        grid-column: 1 / 4;
        width: 100%;
        height: 78px;
        color: $blue-main;
        font-family: $istok-font;
        font-size: 24px;
        font-weight: 700;
        letter-spacing: 0.38px;
        line-height: 30px;
        @media (max-width: $xl-up) {
            width: 90%;
        }
        @media (max-width: $lg-up) {
            width: 250px;
        }
        @media (max-width: $sm-up) {
            width: 295px;
            height: 18px;
            color: #0a294a;
            font-size: 14px;
            letter-spacing: 0.22px;
            line-height: 18px;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            width: 295px;
            height: 18px;
            font-size: 14px;
            letter-spacing: 0.22px;
            line-height: 18px;
        }
    }
    &__logo {
        grid-row-start: 2;
        grid-column: auto;
        justify-self: left;
        align-self: auto;
        @media (max-width: $xl-up) {
            align-self: center;
        }
        @media (min-width: $xxs-up) and (max-width: $xs-up) {
            height: 30px;
        }
    }

    &__logo:hover {
        margin-top: 2px;
    }
}
</style>
